// import './MenuNavBar.css';
// import { NavLink } from 'react-router-dom';

// const MenuNavBar = () => {    
//   return (
//     <div className='nav-menu-bar'>
//         <div className='navContainer'>
//             <ul>
//                 <li>                
//                     <NavLink exact activeClassName="home_active_menu_item" className="home_inactive_menu_item" to="/"> Home </NavLink>
//                 </li>
//                 {/* <li>                
//                     <NavLink exact activeClassName="home_active_menu_item" className="home_inactive_menu_item" to="/HallOfFame"> Hall of Fame </NavLink>
//                 </li> */}
//                 <li>
//                     <NavLink exact activeClassName="home_active_menu_item" className="home_inactive_menu_item" to="/SocialLearning"> Social Learning </NavLink>                
//                 </li>
//                 <li>
//                     <NavLink exact activeClassName="home_active_menu_item" className="home_inactive_menu_item" to="/emotion"> Emotion Captures </NavLink>                
//                 </li>
//                 <li>
//                     <NavLink exact activeClassName="home_active_menu_item" className="home_inactive_menu_item" to="/faq"> FAQ </NavLink>                
//                 </li>
//             </ul>
//         </div>
//     </div>         
//   )
// }

// export default MenuNavBar;
import React,{useState} from 'react';
import {NavLink, Link} from 'react-router-dom';
import {FiAlignRight,FiXCircle,FiChevronDown,FiChevronRight } from "react-icons/fi";
import './MenuNavBar.css';
import { useMsal } from "@azure/msal-react";
import { HashLink } from 'react-router-hash-link';

const MenuNavBar = (props) => {
    const [isMenu, setisMenu] = useState(false);
    const [isResponsiveclose, setResponsiveclose] = useState(false);
    const toggleClass = () => {
      setisMenu(isMenu === false ? true : false);
      setResponsiveclose(isResponsiveclose === false ? true : false);
    };
    let boxClass = ["main-menu"];
    if(isMenu) {
        boxClass.push('menuq2');
    }else{
        boxClass.push('');
    }  

    const [isMenuSubMenu, setMenuSubMenu] = useState(false);
    const toggleSubmenu = () => {
     setMenuSubMenu(isMenuSubMenu === false ? true : false);
    };
    let boxClassSubMenu = ["sub__menus"];
    if (isMenuSubMenu) {
     boxClassSubMenu.push("sub__menus__Active");
    } else {
     boxClassSubMenu.push("");
    }

    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();      
    let loggedInCareerLevel = "";
    let loggedInEnterpriseId = "";
    if (activeAccount) {      
      loggedInCareerLevel = activeAccount.idTokenClaims.jobFamilyDescription;
      loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;      
    }
    console.log(activeAccount);      
    const allowedEnterpriseId = [
      "devika.gajanan.pote",
      "s.saraswathi",
      "praveen.rajaram",
      "ashfaque.mundewadi",
      "madhuri.gattu",
      "veena.bharadwaj",
      "srimoyee.b.das",
      "divya.p.sivakumar",
      "ankur.e.mishra",
      "sonali.ajit.adsule",
      "smita.chavan",
      "s.x.thakur",
      "a.kabra",
      "kondanna.nakanamoni",
      "varsha.a.tyagi",
      "prateek.a.mathur",
      "sudharshan.a.reddy",
      "tarun.motiwala",
      "smita.chavan",
      "aparna.gg",
      "amit.rambhia",
      "arpita.m.singh",
      "praharsha.singh",
      "shubham.khattri",
      "raja.chinthalapudi",
      "n.a.ashok.kulkarni",
      "sudheendra.n.teggi",
      "aruna.kumari",
      "rakesh.d.gowda",
      "nikhil.c.bajaj",
      "neha.m.mehta",
      "pranjal.rasane"         
    ]

    return (
      <div className="header__middle">
        <div className="head-container">
            <div className="header__middle__menus">
              <nav className="main-nav ">
                {/* Responsive Menu Button */}
                {isResponsiveclose === true ? (
                  <>
                    <span
                      className="menubar__button"
                      style={{ display: "none" }}
                      onClick={toggleClass}
                    >
                      {" "}
                      <FiXCircle />{" "}
                    </span>
                  </>
                ) : (
                  <>
                    <span
                      className="menubar__button"
                      style={{ display: "none" }}
                      onClick={toggleClass}
                    >
                      {" "}
                      <FiAlignRight />{" "}
                    </span>
                  </>
                )}
                <ul className={boxClass.join(" ")}>
                  <li className="menu-item">
                    <NavLink
                      onClick={toggleClass}
                      activeClassName="is-active"
                      className="nav-links"
                      to="/home"
                    >
                     Home
                    </NavLink>
                  </li>
                  {/* <li className="menu-item">
                    <NavLink
                      onClick={toggleClass}
                      activeClassName="is-active"
                      className="nav-links"
                      to="/HallOfFame"> Hall of Fame </NavLink>
                  </li> */}
                  {/* <li className="menu-item">
                    <NavLink
                      onClick={toggleClass}
                      activeClassName="is-active"
                      className="nav-links"
                      to="/learners"
                    >
                      {" "}
                      Learners{" "}
                    </NavLink>{" "}
                  </li> */}
                  <li className="menu-item">
                    <NavLink
                      onClick={toggleClass}
                      activeClassName="is-active"
                      className="nav-links"
                      to="/SocialLearning"> Social Learning </NavLink>
                  </li>
                  <li className="menu-item">
                    <NavLink
                      onClick={toggleClass}
                      activeClassName="is-active"
                      className="nav-links"
                      to="/emotion"> Emotion Capture </NavLink>
                  </li>
                  <li className="menu-item">
                    <NavLink
                      onClick={toggleClass}
                      activeClassName="is-active"
                      className="nav-links"
                      to="/faq"> FAQ </NavLink>   
                  </li>                  
                  {(loggedInCareerLevel !== ""  && loggedInCareerLevel != 7 && loggedInCareerLevel != 8 && loggedInCareerLevel != 9 && loggedInCareerLevel != 10 
                    && loggedInCareerLevel != 11 && loggedInCareerLevel != 12) || allowedEnterpriseId.includes(loggedInEnterpriseId) ? 
                  <li onClick={toggleSubmenu} className="menu-item sub__menus__arrows"> 
                    <Link
                      onClick={toggleClass}
                      activeClassName="is-active"
                      className="nav-links"
                     > Dashboard 
                      <span style={{verticalAlign:'middle'}}>
                      <FiChevronDown />
                      </span>
                      </Link>  
                      <ul className={boxClassSubMenu.join(" ")}>
                    {/* <li className="sub__menus__arrows2">
                      <HashLink
                        onClick={toggleClass}                        
                        className="nav-links"                        
                        style={{cursor:'pointer',color:'black',fontFamily:'graphik-bold',fontSize:'14px'}}
                        to="/learningdashboard"
                      >
                        
                        Learning Dashboard
                      </HashLink>  
                      </li> */}
                      <li className="sub__menus__arrows2">
                      <HashLink
                        onClick={toggleClass}                        
                        className="nav-links"                        
                        style={{cursor:'pointer',color:'black',fontFamily:'graphik-bold',fontSize:'14px'}}
                        to="/certificationdashboard"
                      >
                        
                        Certification Dashboard
                      </HashLink>  
                      </li>
                      </ul>
                  </li> : ''}
                </ul>
              </nav>
            </div>
        </div>
      </div>
    );
}

export default MenuNavBar;
